import { createStoreModule } from '../utils';
export default createStoreModule({
  name: 'invoice',
  modelName: 'invoices',
  crud: true,
  endpoint: '/v2/invoices'
});
